import type { ReactElement } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import * as siRoutes from "app/pages/sales-intelligence/constants/routes";
import { StyledAIOutreachIconButton } from "app/pages/sales-intelligence/modules/ai-agent/components/styles";
import homePageTrackingService from "app/pages/sales-intelligence/services/tracking/home-page/trackingService";
import { isContactNameHidden } from "app/pages/sales-intelligence/sub-modules/contacts-search/utils/isContactNameHidden";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import TruncatedTextWithTooltip from "../../../../common-components/TruncatedText/TruncatedTextWithTooltip";

import OpportunitySpottedErrorState from "./OpportunitySpottedErrorState";
import OpportunitySpottedLoadingState from "./OpportunitySpottedLoadingState";
import { StyledOpportunitySpottedStack } from "./styles";

interface IProps {
    companyDomain: string;
    isLoading: boolean;
    text?: string;
    contactName?: string;
}

const TopCompanyOpportunitySpotted = ({ companyDomain, text, isLoading, contactName = "" }: IProps): ReactElement => {
    const craftAnEmailLink: string = proNavigator.href(siRoutes.AI_AGENT_EMAIL, {
        domain: companyDomain,
        recipient: isContactNameHidden(contactName) || !contactName ? undefined : contactName,
        autogenerate: true,
    });

    const handleCraftEmail = (): void => {
        homePageTrackingService.trackCraftEmail();
    };

    const opportunitySpottedText = text ? (
        <TruncatedTextWithTooltip
            fontVariant="value"
            color={colorsPalettes.midnight[400]}
            lineClamp={2}
        >
            {text}
        </TruncatedTextWithTooltip>
    ) : (
        <OpportunitySpottedErrorState />
    );

    return (
        <StyledOpportunitySpottedStack
            justifyContent="space-between"
            gap="8px"
            height="100%"
        >
            {isLoading ? <OpportunitySpottedLoadingState /> : opportunitySpottedText}

            <Flex
                justifyContent="flex-end"
                width="100%"
            >
                <a
                    href={craftAnEmailLink}
                    target="_blank"
                    onClick={handleCraftEmail}
                >
                    <StyledAIOutreachIconButton iconName="ai-email">
                        {translate("primary.sidebar.salesIntelligence.email")}
                    </StyledAIOutreachIconButton>
                </a>
            </Flex>
        </StyledOpportunitySpottedStack>
    );
};

export default TopCompanyOpportunitySpotted;
